import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddNewCategorieModal",
  tabindex: "-1",
  ref: "addAddNewCategorieModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" })
], -1)
const _hoisted_5 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégories "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}, " Envoyer ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", null, "Vous voulez ajouter de(s) nouveau(x) catégorie(s) à cette marque: " + _toDisplayString($props.selectedMarque?.nom), 1),
          _createVNode(_component_Form, {
            ref: "categorieForm",
            onSubmit: _ctx.addCategorie,
            "validation-schema": _ctx.categorieSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Field, { name: "categorie" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.categoriesOptions,
                          searchable: true,
                          multiple: "true",
                          mode: "tags",
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le categorie" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "categorie",
                    class: "text-danger"
                  })
                ]),
                _hoisted_10
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _hoisted_11
      ])
    ])
  ], 512))
}